import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { PaginationDot } from './PaginationDot';

const rootStyles = {
  position: 'absolute',
  bottom: '10%',
  right: '50%',
  display: 'flex',
  flexDirection: 'row',
  marginRight: `${-108}px`,
};

/**
 * @todo
 * This component may be of poor quality and may not work as intended.
 * There are also a few competing components that may be better suited.
 * Future improvement work should consider refactoring/removing this component
 * to raise the quality of the codebase.
 */
class Pagination extends Component {
  handleClick(event, index) {
    this.props.onChangeIndex(index);
  }

  render() {
    const { index, dots } = this.props;

    const children = [];

    for (let i = 0; i < dots; i++) {
      children.push(
        <PaginationDot
          key={i}
          index={i}
          active={i === index}
          onClick={this.handleClick}
        />
      );
    }

    return (
      <div className="demo-pagination" style={rootStyles}>
        {children}
      </div>
    );
  }
}

Pagination.propTypes = {
  dots: PropTypes.number.isRequired,
  index: PropTypes.number.isRequired,
  onChangeIndex: PropTypes.func.isRequired,
};

export { Pagination };
